/* HT fix 2026-07-27 (Claude): el buscador de HT (barra grande "por numero de parte" y la mini
   busqueda del header, ambas comparten la clase .js_iput_search) pegaba a /search?view=js, una
   plantilla propia del tema con relevancia pobre para codigos tecnicos (ej. "tipo15" mezclaba
   correas PK/5VX/3VX). Search & Discovery SI mejora bien los resultados, pero solo en el endpoint
   nativo de Predictive Search (routes.predictive_search_url) -- confirmado comparando ambos
   endpoints en vivo. Este script no toca el archivo generado assets/jquery.interact-function.js
   (Shopify bloquea editarlo directamente); en su lugar espera a que ese archivo termine de
   registrar su handler de keyup, lo desactiva, y lo reemplaza por uno que pega al endpoint bueno,
   manteniendo exactamente las mismas clases de tarjeta (.item .product-item .product-image
   .product-content .product-title .product-price) para no tocar ningun CSS.

   v2 (mismo dia): el endpoint nativo tokeniza por palabra y hace prefix-match por token. Los
   titulos de HT llevan el codigo separado ("Correa Automotriz Tipo 15481"), pero los clientes
   suelen escribirlo pegado ("tipo15", "correas tipo15" -- fue el caso exacto que reporto el
   usuario). Pegado, "tipo15" no calza con ningun token del titulo y da 0 resultados. Se agrega
   una normalizacion que separa letra+numero pegados antes de consultar, con reintento usando el
   texto original si la version separada no encuentra nada (por si el codigo real SI va pegado).

   v3 2026-07-28 (Claude): se agrega "tag" a resources[options][fields]. Shopify Predictive Search
   por default SOLO busca en title/variants.title/vendor/product_type -- NUNCA en tags, aunque el
   producto este correctamente tagueado. Verificado en vivo: el tag "PK" agregado el 2026-07-27 a
   479 productos (Correa Automotriz PK + Correas Serpentina PK) esta bien puesto en el catalogo,
   pero "pk", "correa pk" y "serpentina" seguian dando 0/resultados irrelevantes porque el fetch
   nunca pedia el campo tag. Con fields incluyendo tag, "serpentina" y "correa pk" ya devuelven las
   correas correctas. (No se agrega "body" al listado de campos: description completa mete
   demasiado ruido -- cualquier mencion incidental de una palabra en el texto largo empieza a
   matchear productos no relacionados.)

   v3.1 2026-07-28 (Claude): bug encontrado en vivo -- cuando 0 productos, el mensaje
   ".ht-np-no-results" se pintaba pero quedaba INVISIBLE (texto blanco heredado de .js_prs_search,
   sobre fondo transparente = texto blanco sobre blanco). El dropdown se veia completamente en
   blanco para el cliente, exactamente como reporto el usuario buscando "mascara de soldador" --
   el producto usa "careta" en el catalogo asi que 0 resultados es correcto (ver doc de sinonimos),
   pero el mensaje de "no encontramos" tenia que ser legible y no lo era. Se agrega estilo inline
   con color oscuro y padding para que sea visible sin depender de CSS del tema.

   v3.2 2026-07-28 (Claude): segundo bug encontrado en vivo, reportado por el usuario con captura --
   al BORRAR el texto de la barra (seleccionar todo + suprimir, o borrar letra por letra hasta
   vaciarla) el dropdown de resultados quedaba pegado en pantalla mostrando los resultados de la
   ULTIMA busqueda con texto (ej. buscar "rodamiento", ver resultados, borrar todo -> la barra
   queda vacia pero los rodamientos se siguen viendo). Causa: el guard `val_currect == ''` cortaba
   el handler ANTES de limpiar el contenido de .js_prs_search o de sacarle la clase "open_result"
   a .laber_search/.mini_cart_wrap -- esas clases son las que controlan si el dropdown se ve o no,
   y solo se agregaban, nunca se quitaban. Se agrega limpieza explicita (vaciar $result, sacar
   "open_result", ocultar el panel) cuando el campo queda vacio, antes del return. */
(function () {
  'use strict';

  function htEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function htRenderCard(p) {
    var img = p.image ? (p.image + '&width=533') : '';
    var cur = parseFloat(p.price || p.price_min || 0).toFixed(2);
    var showCompare = parseFloat(p.compare_at_price_min || 0) > parseFloat(p.price_min || 0);
    var cmp = showCompare ? '<span class="compare">$' + parseFloat(p.compare_at_price_min).toFixed(2) + '</span>' : '';
    return '<div class="item">'
      + '<div class="product-item">'
      + '<div class="product-image">'
      + '<a href="' + p.url + '" class="image_product">'
      + '<img src="' + img + '" alt="' + htEsc(p.title) + '" class=" motion-reduce default_media" loading="lazy">'
      + '</a>'
      + '</div>'
      + '<div class="product-content">'
      + '<a class="product-title " href="' + p.url + '">' + htEsc(p.title) + '</a>'
      + '<div class="product-price"><span class="current">$' + cur + '</span>' + cmp + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  function htNormalizeQuery(q) {
    /* separa letra+numero pegados en ambas direcciones: "tipo15"->"tipo 15", "15tipo"->"15 tipo" */
    return q.replace(/([a-zA-Z])(\d)/g, '$1 $2').replace(/(\d)([a-zA-Z])/g, '$1 $2');
  }

  function htFetchProducts(q) {
    var htUrl = window.routes.predictive_search_url
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[limit]=8'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,variants.title,vendor,product_type,tag';
    return fetch(htUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (data.resources && data.resources.results && data.resources.results.products) || [];
      });
  }

  function htSearch(rawQuery) {
    var normalized = htNormalizeQuery(rawQuery);
    return htFetchProducts(normalized).then(function (products) {
      if (products.length || normalized === rawQuery) return products;
      /* fallback: probar el texto tal cual lo escribio el cliente, por si el codigo real va pegado */
      return htFetchProducts(rawQuery);
    });
  }

  function htAttach($) {
    var timer = 0, val_old, val_currect;

    $(document).on('keyup.htPredictive', '.js_iput_search', function (e, bl) {
      var _this = $(this);
      var frm = _this.closest('form');
      var btn = frm.find('.js_btn_search');
      var $result = $('.js_prs_search');
      var ld_bar = $('.ld_bar_search');
      var skeleto = $('.skeleton_js');
      val_currect = _this.val();

      if (val_currect == '') {
        $('.search_header__prs').hide();
        $result.html('');
        $('.laber_search').removeClass('open_result');
        $('.mini_cart_wrap').removeClass('open_result');
        val_old = val_currect;
        return;
      }
      $('.search_header__prs>.keywords').html(val_currect).parents('.search_header__prs').show();
      if (val_old == val_currect && bl != '1') return;

      ld_bar.addClass('on_star');
      $result.hide();
      skeleto.removeClass('d-none-important');
      btn.addClass('pe_none');
      $('.laber_search').addClass('open_result');
      $('.mini_cart_wrap').addClass('open_result');

      clearTimeout(timer);
      timer = setTimeout(function () {
        htSearch(val_currect)
          .then(function (products) {
            if (!products.length) {
              $result.html('<p class="ht-np-no-results" style="color:#333;padding:15px;font-size:14px;line-height:1.4;">No encontramos productos con ese término. Probá con el número de parte exacto, o escribinos por WhatsApp y te ayudamos a encontrarlo.</p>');
            } else {
              $result.html(products.map(htRenderCard).join(''));
            }
            $('.search_header__prs .h_results').show();
            val_old = val_currect;
          })
          .catch(function () {
            $result.html('<p class="ht-np-no-results" style="color:#333;padding:15px;font-size:14px;line-height:1.4;">Ocurrió un error buscando. Intentá de nuevo.</p>');
          })
          .finally(function () {
            btn.removeClass('pe_none');
            ld_bar.addClass('on_end');
            setTimeout(function () {
              ld_bar.attr('class', '').addClass('ld_bar_search');
              skeleto.addClass('d-none-important');
              $result.show();
            }, 280);
          });
      }, 400);
    });
  }

  function htFindLegacyKeyupHandler($) {
    try {
      var events = $._data ? $._data(document, 'events') : ($(document).data('events'));
      if (!events || !events.keyup) return false;
      for (var i = 0; i < events.keyup.length; i++) {
        if (events.keyup[i].selector === '.js_iput_search') return true;
      }
    } catch (err) {
      return false;
    }
    return false;
  }

  var attempts = 0;
  var maxAttempts = 100; /* ~20s at 200ms */
  var poll = setInterval(function () {
    attempts++;
    var $ = window.jQuery;
    if ($ && window.routes && window.routes.predictive_search_url && htFindLegacyKeyupHandler($)) {
      clearInterval(poll);
      $(document).off('keyup', '.js_iput_search');
      htAttach($);
    } else if (attempts >= maxAttempts) {
      /* HT: no se pudo confirmar el handler viejo (tema pudo cambiar el loader) -- no forzamos
         el swap para no quedarnos sin buscador funcionando; el buscador original sigue activo. */
      clearInterval(poll);
    }
  }, 200);
})();
